"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstatePhaseType = void 0;
var EstatePhaseType;
(function (EstatePhaseType) {
    EstatePhaseType[EstatePhaseType["ESTATE"] = 0] = "ESTATE";
    EstatePhaseType[EstatePhaseType["PHASE"] = 1] = "PHASE";
})(EstatePhaseType = exports.EstatePhaseType || (exports.EstatePhaseType = {}));
